import api from "./api";

/**
 * Obtém os logs de disparo do robô RPA com filtros e paginação.
 * @param {Object} params - Parâmetros de filtro e paginação
 * @returns {Promise<Object>} Resposta da API
 */
export const obterDisparosRobo = async (params = {}) => {
  const { data } = await api.get("/relatorios/disparos-robo", { params });
  return data;
};
